import React from 'react'
import {
  AccordionCard,
  AccordionHeader,
  AccordionHeaderLeft,
  AccordionHeaderRight,
  AccordionBusinessName,
  ChevronIcon,
  AccordionBody,
  AccordionHActionWrap,
} from '../AccountInfo.style'

function Chevron() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path
        d="M4 6.5l5 5 5-5"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Accordion({
  isParent = false,
  isMultiLocation,
  badge,
  headerExtra,
  businessName,

  isOpen,
  onToggle,

  children,

  actions,
}) {
  return (
    <AccordionCard>
      {isMultiLocation && (
        <AccordionHeader
          type="button"
          onClick={onToggle}
          aria-expanded={isOpen}
          isOpen={isOpen}
        >
          <AccordionHeaderLeft>
            {badge}

            {/* Show business name only when collapsed */}
            {!isOpen && businessName && (
              <AccordionBusinessName>{businessName}</AccordionBusinessName>
            )}

            {headerExtra && (
              <span onClick={e => e.stopPropagation()}>{headerExtra}</span>
            )}
          </AccordionHeaderLeft>

          <AccordionHeaderRight>
            {actions && (
              <AccordionHActionWrap onClick={e => e.stopPropagation()}>
                {actions}
              </AccordionHActionWrap>
            )}

            <ChevronIcon isOpen={isOpen}>
              <Chevron />
            </ChevronIcon>
          </AccordionHeaderRight>
        </AccordionHeader>
      )}

      {isOpen && <AccordionBody>{children}</AccordionBody>}
    </AccordionCard>
  )
}
